import { render, staticRenderFns } from "./ledgers.vue?vue&type=template&id=ed783788&lang=html&"
import script from "./ledgers.vue?vue&type=script&lang=js&"
export * from "./ledgers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports